/* ============================================================================
   Pet's Table — Landing pages de tráfico frío
   Archivo compartido de configuración y comportamiento.
   Cárgalo en TODAS las landings:
     <script src="assets/pt-landing.js" defer></script>
   y marca la página con:  <body data-pt-page="comida-real">

   Controla dos cosas:
     1) PROMOCIÓN  — apagada por defecto (ver PT_CONFIG.promo)
     2) CTA + UTMs — destino único, conserva UTMs entrantes y añade el id de página
   ========================================================================== */
(function () {
  'use strict';

  /* --------------------------------------------------------------------
     1. CONFIGURACIÓN GLOBAL
     --------------------------------------------------------------------
     PROMO: actualmente ACTIVA al deploy (40% OFF primer pedido, verificada en checkout). Para apagar: active:false.
     Ninguna landing muestra descuentos, urgencia ni vigencias mientras
     `promo.active` sea false. Para restaurar una oferta VERIFICADA:

       promo: {
         active: true,
         text:   '25% OFF en tu primera orden',   // texto aprobado por marketing
         legal:  'Vigencia al 30 de septiembre de 2026. Aplica en la primera orden.'
       }

     Reglas de redacción para `text` / `legal`:
       · Sin "hoy", "últimas horas", "solo por hoy" ni contadores falsos.
       · Sin vigencias que no estén confirmadas por el equipo comercial.
       · El descuento debe existir realmente en el checkout de form.petstable.mx.
     -------------------------------------------------------------------- */
  var PT_CONFIG = {
    promo: {
      active: true,
      text: '\ud83d\udd25 40% OFF en tu primer pedido',
      legal: 'Aplica en tu primer pedido.'
    },
    // Copy neutral que se muestra en la barra superior cuando NO hay promo.
    barFallback: 'Comida real cocida para perros · Envío gratis · Cancela cuando quieras',
    // Destino único del CTA.
    /* 14-ago: de vuelta al formulario. Mientras el one-pager esté apagado
       (PT_SPLIT_ACTIVO = false en pt-form-split.liquid), las landings no
       pueden ser la puerta trasera que siga mandando gente ahí.
       Para retomar el experimento: volver a '/pages/order'. */
    formUrl: 'https://form.petstable.mx/',
    // Texto único del CTA primario.
    ctaLabel: 'Calcula su plan ideal'
  };

  window.PT_CONFIG = window.PT_CONFIG || PT_CONFIG;
  PT_CONFIG = window.PT_CONFIG;

  /* --------------------------------------------------------------------
     2. UTILIDADES
     -------------------------------------------------------------------- */
  function pageId() {
    var b = document.body;
    return (b && b.getAttribute('data-pt-page')) ||
      (location.pathname.split('/').pop() || 'landing').replace(/\.html?$/i, '') ||
      'landing';
  }

  /**
   * Construye el destino del CTA:
   *  - parte de PT_CONFIG.formUrl (con sus propios parámetros, si tuviera)
   *  - copia TODOS los parámetros entrantes de la landing (utm_*, fbclid, gclid…)
   *    sin sobrescribir los que ya trae el destino
   *  - añade identificadores de página SIN pisar UTMs existentes:
   *      pt_lp        → siempre (parámetro propio, nunca choca con UTMs)
   *      utm_content  → solo si no viene ya en la URL
   */
  function buildDestination(id) {
    var target;
    try { target = new URL(PT_CONFIG.formUrl, location.href); }
    catch (e) { return PT_CONFIG.formUrl; }

    var incoming = new URLSearchParams(location.search);
    incoming.forEach(function (value, key) {
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });

    target.searchParams.set('pt_lp', id);                       // identificador de página
    if (!target.searchParams.has('utm_content')) {
      target.searchParams.set('utm_content', id);               // fallback, nunca sobrescribe
    }

    /* Variante del A/B del home (Essential A/B Testing), si esta visita está
       repartida en ese test. La expone el snippet pt-home-variant, que
       pt-landing-head carga antes que este archivo.

       Va AQUÍ y no solo en el listener de pt-landing-head porque esta función
       reconstruye el destino desde cero —también en el click handler de init()—
       y se llevaría por delante cualquier parámetro puesto antes.

       La guarda `window.PT_homeVariant &&` es necesaria: este asset lo usan las
       once landings, y las que no rendericen el snippet no tendrán la función. */
    if (window.PT_homeVariant) {
      var homeVariant = window.PT_homeVariant();
      if (homeVariant) target.searchParams.set('pt_home_variant', homeVariant);
    }

    return target.toString();
  }

  function isFormLink(a) {
    var href = a.getAttribute('href') || '';
    /* Se aceptan los dos destinos: /pages/order es el del experimento y
       form.petstable.mx queda por si algún CTA suelto todavía lo usa. Sin
       esto, cambiar el destino habría dejado los enlaces sin decorar y cada
       clic llegaría sin utm_*, sin tw_adid y sin pt_lp. */
    return href.indexOf('form.petstable.mx') !== -1 ||
           href.indexOf('/pages/order') !== -1;
  }

  /* --------------------------------------------------------------------
     3. APLICACIÓN
     -------------------------------------------------------------------- */
  function applyPromo() {
    var active = !!(PT_CONFIG.promo && PT_CONFIG.promo.active && PT_CONFIG.promo.text);
    var root = document.documentElement;
    root.setAttribute('data-pt-promo', active ? 'on' : 'off');

    // Texto de la promo
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-promo-text]'), function (el) {
      el.textContent = active ? PT_CONFIG.promo.text : '';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-promo-legal]'), function (el) {
      el.textContent = active ? (PT_CONFIG.promo.legal || '') : '';
    });
    // Bloques que solo existen si hay promo / si no hay promo
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-promo-only]'), function (el) {
      el.hidden = !active;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-nopromo]'), function (el) {
      el.hidden = active;
    });
  }

  function applyCtas() {
    var id = pageId();
    var dest = buildDestination(id);
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      if (!isFormLink(a)) return;
      a.setAttribute('href', dest);
      a.setAttribute('rel', 'noopener');
      if (a.hasAttribute('data-pt-cta')) a.textContent = PT_CONFIG.ctaLabel;
    });
  }

  function init() {
    applyPromo();
    applyCtas();
    // Reaplica el destino al hacer clic (por si la URL cambió por un router/anchor)
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (a && isFormLink(a)) a.setAttribute('href', buildDestination(pageId()));
    }, true);
  }

  /* API pública — útil para QA y para activar una promo verificada en runtime:
       PT.setPromo({ active:true, text:'…', legal:'…' })
     En producción, edita PT_CONFIG.promo arriba en vez de usar la API. */
  window.PT = {
    config: PT_CONFIG,
    applyPromo: applyPromo,
    applyCtas: applyCtas,
    buildDestination: buildDestination,
    setPromo: function (promo) {
      PT_CONFIG.promo = promo || { active: false, text: '', legal: '' };
      applyPromo();
      return PT_CONFIG.promo;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
